import API from '@/services/spinampApi';
import {IApiResponseExplore} from '@/types/api';

export const fetchExploreData = (): Promise<IApiResponseExplore> =>
  API.get('/config/explore');
